import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader } from "lucide-react";

export default function AuthCallback() {
  const { exchangeSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/connexion", { replace: true });
      return;
    }

    const sessionId = match[1];
    exchangeSession(sessionId)
      .then(() => navigate("/profil", { replace: true }))
      .catch(() => navigate("/connexion?error=google", { replace: true }));
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0C] flex items-center justify-center">
      <div className="text-center">
        <Loader className="w-8 h-8 text-[#FF5C00] animate-spin mx-auto mb-3" />
        <p className="text-white/50 text-sm">Connexion avec Google…</p>
      </div>
    </div>
  );
}
